import { AdminInput, Button, Div, H3, Modal, P } from '@vgrubs/components';
import { useEffect, useState } from 'react';

/** The backend refuses a longer reason. */
const MAX_REASON_LENGTH = 1000;

/**
 * Asks why before rejecting a vDrive request. The reason is required (blank or
 * spaces only is a 400) and the owner reads it by push and in the support chat.
 * The reject reaches every location on the same vDrive balance that is still
 * waiting, so the copy says so.
 */
export const RejectVDriveModal = ({
  isOpen,
  closeModal,
  onConfirm,
  loading,
  locationName,
}: {
  isOpen: boolean;
  closeModal: () => void;
  onConfirm: (reason: string) => void;
  loading: boolean;
  locationName?: string;
}) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (!isOpen) setReason('');
  }, [isOpen]);

  const trimmed = reason.trim();
  const canReject =
    !!trimmed && trimmed.length <= MAX_REASON_LENGTH && !loading;

  return (
    <Modal isOpen={isOpen} closeModal={closeModal} logo={false}>
      <H3 $m="10px" $center>
        Reject vDrive
      </H3>
      <P $mb="24" $center>
        Reject the vDrive request for {locationName || 'this location'}? Other
        locations on the same vDrive balance that are still waiting for
        verification are rejected too. The owner gets this reason.
      </P>

      <AdminInput
        type="textarea"
        placeholder="Enter rejection reason"
        value={reason}
        maxLength={MAX_REASON_LENGTH}
        onChange={(e) => setReason(e.target.value)}
      />

      <Div $flex $gap="16px" $mt="24">
        <Button
          $w="100%"
          $selected
          onClick={() => onConfirm(trimmed)}
          disabled={!canReject}
        >
          Reject
        </Button>
        <Button $w="100%" $gray $selected onClick={closeModal}>
          Cancel
        </Button>
      </Div>
    </Modal>
  );
};
